/**
 * Which build this is.
 *
 * Compiled in by Vite (see vite.config.ts) rather than read at runtime: the
 * client is a static bundle served by the game server, so there is nothing to
 * ask. The number on the title screen is therefore the number of the bundle
 * you are actually looking at, which is the whole point of showing it — a
 * version fetched from somewhere else could describe a different build.
 */

declare const __BUILD_VERSION__: string;
declare const __BUILD_COMMIT__: string;

/** Semantic version from the root manifest, e.g. "0.2.0". */
export const BUILD_VERSION: string =
  typeof __BUILD_VERSION__ === 'string' ? __BUILD_VERSION__ : '0.0.0';

/** Short commit hash, or empty where the build had no git to ask. */
export const BUILD_COMMIT: string =
  typeof __BUILD_COMMIT__ === 'string' ? __BUILD_COMMIT__ : '';

/** What the title screen shows: "v0.2.0 · a1b2c3d". */
export const BUILD_LABEL = BUILD_COMMIT
  ? `v${BUILD_VERSION} · ${BUILD_COMMIT}`
  : `v${BUILD_VERSION}`;
